import { Injectable } from "@angular/core";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

@Injectable({
    providedIn: 'root',
})
export class FcmTokenService {
    firebaseConfig = {
        apiKey: 'AIzaSyC_MZyIIX_VpnFQMYPRRY7DNQOVG3KJ3rk',
        authDomain: 'dpworks-demo.firebaseapp.com',
        projectId: 'dpworks-demo',
        storageBucket: 'dpworks-demo.appspot.com',
        messagingSenderId: '239109084805',
        appId: '1:239109084805:web:e7c83b9eb3f9e8d7737bec',
        measurementId: 'G-VK2VH5LRW8',
        vapidKey:
            'BPJDztmMpyNPDDEpg87-PU5WtnPEU93AuZQdBjyLnSlQnqleYOgcUA63djqv9MozBG5zsOiYhdfCCbfnBiyIz74',
    };
    app = initializeApp(this.firebaseConfig);
    messaging = getMessaging(this.app);
    initializeFCM(): Promise<boolean> {
        return navigator.serviceWorker.getRegistration("./firebase-messaging-sw.js")
            .then((registration) => {
                return getToken(this.messaging, {
                    vapidKey: this.firebaseConfig.vapidKey,
                    serviceWorkerRegistration: registration
                }).then((currentToken) => {
                    if (currentToken) {
                        console.log(currentToken);
                        const FCM_TOKEN = 'fcm_token';
                        localStorage.setItem(FCM_TOKEN, currentToken);
                        return true;
                    } else {
                        console.log('No registration token available');
                        return false;
                    }
                }).catch((err) => {
                    console.error("An error occurred while retrieving token ", err);
                    return false;
                });
            })
            .catch((err) => {
                console.error("An error occurred while getting service worker registration", err);
                return false;
            });
    }
}